import { useQuery } from 'react-query';
import { configAPI } from '../services/configApi';

// Runtime settings the server decides (AWS_DEPLOYMENT_PLAN.md C4). Fetched once per session:
// they change only with a redeploy, which reloads the page anyway. `config` is undefined until
// the first answer, so callers render nothing that depends on it until then rather than
// guessing a default that could offer a control the server would refuse.
export default function usePublicConfig() {
  const query = useQuery(
    ['public-config'],
    () => configAPI.getPublic().then((response) => response.data),
    { staleTime: Infinity, cacheTime: Infinity, retry: 2 }
  );
  return { config: query.data, isLoading: query.isLoading, isError: query.isError };
}
